
import { fork, call, put, all, takeEvery } from "redux-saga/effects";
import asyncInterface from "../../../../asyncInterface";
import * as actionTypes from "./actionTypes";

function fetchAccountData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.exchangeActivity.fetchAccountData(fetchPayload);
}

function postActivityData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.exchangeActivity.postActivityData(fetchPayload);
}

function* exchangeActivitySingle(data) {
  try {
    yield put({
      type: actionTypes.isLoadingType,
      payload: true
    });
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.fetchEaSingleDataType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: actionTypes.fetchEaSingleDataFailType,
      error
    });
  }
}

function* exchangeActivityRecurring(data) {
  try {
    yield put({
      type:  actionTypes.isLoadingType,
      payload: true
    });
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.fetchReDataType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: actionTypes.cancelTxnScheduleType,
      error
    });
  }
}
let cancelCount = 1;
let cancelRecount = 1;
function* cancelExchangeWorker(data) {
  try {
    const response = yield call(postActivityData, data.payload);
    yield put({
      type: actionTypes.cancelExchangeDataType,
      payload: cancelCount++
    });
    yield put({
      type: actionTypes.cancelReExchangeDataType,
      payload: cancelRecount++
    });
  } catch (error) {
    yield put({
      type: actionTypes.cancelExchangeDataType,
      payload: cancelCount++
    });
    yield put({
      type: actionTypes.cancelReExchangeDataType,
      payload: cancelRecount++
    });
  }
}

function* fetchAccountDataWorker(fetchPayload) {
  yield all([
    fork(exchangeActivitySingle, fetchPayload.payload.metaData[0]),
    fork(exchangeActivityRecurring, fetchPayload.payload.metaData[1])
  ]);
}

function* fetchAccountDataWatcher() {
  yield takeEvery(actionTypes.fetchExchangeActivityType, fetchAccountDataWorker);
}

function* cancelExchangeWatcher() {
  yield takeEvery(actionTypes.cancelTxnScheduleType, cancelExchangeWorker);
}
function* cancelRExchangeWatcher() {
  yield takeEvery(actionTypes.cancelReScheduleType, cancelExchangeWorker);
}

export default function* commonSagaWatcher() {
  yield all([
    fork(fetchAccountDataWatcher),
    fork(cancelRExchangeWatcher),
    fork(cancelExchangeWatcher)
  ]);
}




